import React, { useState } from 'react';

const BunnyVideoPlayer = ({ 
  videoId = '0f371cde-3acd-4d12-b189-fde74bd72b58',
  libraryId = '449336',
  autoplay = true,
  loop = false,
  muted = false,
  preload = true,
  responsive = true,
  className = ''
}) => {
  const [isLoading, setIsLoading] = useState(true);
  const [hasError, setHasError] = useState(false);

  const iframeSrc = `https://iframe.mediadelivery.net/embed/${libraryId}/${videoId}?autoplay=${autoplay}&loop=${loop}&muted=${muted}&preload=${preload}&responsive=${responsive}`;

  return (
    <div className={`bunny-player-wrapper ${className}`}>
      <div className="video-container">
        {isLoading && (
          <div className="loading-state">
            <div className="spinner"></div>
            <p>טוען סרטון...</p>
          </div>
        )}
        
        {hasError && (
          <div className="error-state">
            <p>❌ שגיאה בטעינת הסרטון</p>
            <button onClick={() => {
              setHasError(false);
              setIsLoading(true);
            }}>
              נסה שוב
            </button>
          </div>
        )}
        
        <iframe
          src={iframeSrc}
          loading="lazy"
          className="bunny-iframe"
          allow="accelerometer; gyroscope; autoplay; encrypted-media; picture-in-picture"
          allowFullScreen
          onLoad={() => setIsLoading(false)}
          onError={() => {
            setIsLoading(false);
            setHasError(true);
          }}
          style={{ display: hasError ? 'none' : 'block' }}
        />
      </div>
    </div>
  );
};

const App = () => {
  return (
    <div className="main-container">
      <header>
        <h1>בקטסט מאיץ הרווחים</h1>
        <p className="subtitle">17.6.2025 - זום עם חי טל</p>
      </header>

      <BunnyVideoPlayer autoplay={false} />

      <style jsx>{`
        * {
          margin: 0;
          padding: 0;
          box-sizing: border-box;
        }

        .main-container {
          min-height: 100vh;
          background: #ffffff;
          font-family: -apple-system, BlinkMacSystemFont, 'Segoe UI', Arial, sans-serif;
          padding: 40px 20px;
          display: flex;
          flex-direction: column;
          align-items: center;
        }

        header {
          text-align: center;
          margin-bottom: 40px;
        }

        h1 {
          font-size: 2.5rem;
          color: #333;
          margin-bottom: 10px;
        }

        .subtitle {
          font-size: 1.1rem;
          color: #666;
        }

        /* Bunny Player Styles */
        :global(.bunny-player-wrapper) {
          width: 100%;
          max-width: 1200px;
          margin: 0 auto;
        }

        :global(.video-container) {
          position: relative;
          padding-top: 56.25%;
          width: 100%;
          background: #000;
          border-radius: 8px;
          overflow: hidden;
        }

        :global(.bunny-iframe) {
          position: absolute;
          top: 0;
          left: 0;
          width: 100%;
          height: 100%;
          border: 0;
        }

        :global(.loading-state),
        :global(.error-state) {
          position: absolute;
          top: 50%;
          left: 50%;
          transform: translate(-50%, -50%);
          text-align: center;
          color: white;
        }

        :global(.spinner) {
          border: 3px solid rgba(255, 255, 255, 0.3);
          border-radius: 50%;
          border-top: 3px solid white;
          width: 40px;
          height: 40px;
          animation: spin 1s linear infinite;
          margin: 0 auto 15px;
        }

        @keyframes spin {
          0% { transform: rotate(0deg); }
          100% { transform: rotate(360deg); }
        }

        :global(.error-state button) {
          background: #ff5858;
          color: white;
          border: none;
          padding: 10px 20px;
          border-radius: 6px;
          cursor: pointer;
          margin-top: 10px;
          font-size: 14px;
        }

        :global(.error-state button:hover) {
          background: #ff4040;
        }

        @media (max-width: 768px) {
          h1 {
            font-size: 1.8rem;
          }

          .subtitle {
            font-size: 1rem;
          }
        }
      `}</style>
    </div>
  );
};

export default App;